export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7167.9b4f3ff4.jpg";